import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import StopRoundedIcon from "@mui/icons-material/StopRounded";
import { useNavigate, useParams } from "react-router-dom";
import { theme } from "../../components/theme";
import { customDateConvert } from "./Utils/Utils";
import CustomPagination from "./CustomPagination";
import { useSelectTagContext } from "../../context/SelectTagContext";

const styles = {
  itemBox: {
    display: "flex",
    flexDirection: "column",
    p: 1,
    // backgroundColor: isSelected ? "#0077B61A" : "white",
    borderBottom: "1px solid #E4E4E4",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#EFEFEF",
    },
  },
  companyTypography: {
    justifyContent: "space-between",
    display: "flex",
  },
  detailText: {
    fontSize: "13px",
  },
};

function CompanySearchboxBody({
  data,
  onItemSelected,
  currentPage,
  totalPages,
  handleChangePage,
  handleChangeItemsPerPage,
  currentState,
}) {
  const [selectedItemId, setSelectedItemId] = useState(null);
  const { minRows, setMinRows } = useSelectTagContext();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    setSelectedItemId(id);
  }, [id]);

  const handleSelect = (itemId) => {
    setSelectedItemId(itemId);
    navigate(`/qualityInfo/${itemId}`);
  };

  // useEffect(() => {
  //   if (data && data.length > 0 && selectedItemId && onItemSelected) {
  //     const selectedItem = data.find(
  //       (item) => item.partSystemId === selectedItemId
  //     );
  //     if (selectedItem) {
  //       onItemSelected(selectedItem);
  //     }
  //   }
  // }, [selectedItemId, onItemSelected, data]);

  console.log("first",data)

  return (
    <>
      {currentState === "By Parts" ? (
        <>
          {data?.map((item, index) => (
            <Box
              sx={{
                ...styles.itemBox,
                ...(item.partSystemId == selectedItemId && {
                  backgroundColor: "#0077B61A",
                }),
              }}
              key={index}
              onClick={() => handleSelect(item.partSystemId)}
            >
              <Typography sx={styles.companyTypography}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    fontWeight: 500,
                  }}
                >
                  {item.partCode || ""}
                  <div style={styles.detailText}>
                    {customDateConvert(
                      item?.dryTunnelExitTime,
                      "MM/DD/YYYY HH:mm:ss"
                    )}
                  </div>
                </Box>
                <span style={styles.detailText}>
                  <StopRoundedIcon
                    sx={{
                      color:
                        theme.colors[item?.final_status?.toLowerCase()] ||
                        "white",
                      fontSize: "30px",
                    }}
                  />
                </span>
              </Typography>
            </Box>
          ))}
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            changePage={handleChangePage}
            changeItemsPerPage={handleChangeItemsPerPage}
            page={"small"}
            minRows={minRows}
            setMinRows={setMinRows}
          />
        </>
      ) : (
        data?.map((item, index) => (
          <Box
            sx={{
              ...styles.itemBox,
              ...(item.productSystemId == selectedItemId && {
                backgroundColor: "#0077B61A",
              }),
            }}
            key={index}
            onClick={() => handleSelect(item.productSystemId)}
          >
            <Typography sx={styles.companyTypography}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  fontWeight: 500,
                }}
              >
                {item.productCode || ""}
                <div style={styles.detailText}>
                  {item?.percentageScrap}
                  <b>%</b> Scrap
                </div>
              </Box>
              {/* <span style={styles.detailText}>
                <StopRoundedIcon
                  sx={{
                    color:
                      theme.colors[item?.final_status?.toLowerCase()] ||
                      "white",
                    fontSize: "30px",
                  }}
                />
              </span> */}
            </Typography>
          </Box>
        ))
      )}
    </>
  );
}

export default CompanySearchboxBody;
